// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__CdeaB","wrapperItem":"Pagination_wrapperItem__o3jnD"};